import * as types from "../actions/actionType";
import * as _ from "lodash";


const calculateTotalAmountDue = (accounts = []) => {
	return accounts.reduce((sum, acc) => {
		const n = Number(acc && acc.minimum_due_amount);
		return sum + (Number.isFinite(n) ? n : 0);
	}, 0);
};

const accountReducer = (state, action) => { 
	if(state===null || state===undefined){
		state={};
	}
	switch (action.type) {
		case types.LOAD_ACCOUNTS_SUCCESS:
			return {
				...state,
				accountMatchBool: action.accounts.input_account_match,
				customerCount: action.accounts.customer_count,
				accounts: _.keyBy(action.accounts.accounts, "account_number"),
				currentAccount: action.accounts.accounts[0].account_number,
				total_amount_due: calculateTotalAmountDue(action.accounts.accounts),
				error: false,
				errorMessage: "",
				token: action.accounts.access_token,
				pcgx:action.pcgx
			};
		case types.LOAD_ACCOUNTS_FAILED:
			return {
				...state,
				error: true,
				errorInfo: action.errorInfo
			};
		case types.IS_IE:
			return {
				...state,
				isIEFlag:action.isIEFlag
			};
		case types.SET_CURRENT_ACCOUNT:
			return {
				...state,
				currentAccount: action.accountNumber
			};
		case types.SET_CURRENT_POLICY:
			return {
				...state,
				currentPolicy: action.policyNumber
			};
		case types.UPDATE_CURRENT_ACCOUNT:
	let total = 0;

	_.forOwn(action.accountUpdate, accountData => {
		let policy_total = 0;
		let hasAnyPolicyLevelOption = false;
		
		// Check if there's a billing account-level payment option
		const billingPaymentOption = accountData.paymentOption;

		// First pass: check if any policies have their own payment options
		_.forEach(accountData.policies, policy => {
			if (policy.paymentOption) {
				hasAnyPolicyLevelOption = true;
			}
		});


		_.forEach(accountData.policies, policy => {
			let policyAmount = 0;
			// Priority 1: If the policy has its own payment option, use that
			if(accountData.paymentOption){
				policy.paymentOption = accountData.paymentOption;
			}
			if (!billingPaymentOption && policy.paymentOption) {
				// Policy-level payment option (user selected something specifically for this policy)
				if (policy.paymentOption === 'Other amount' && policy.policy_amount > 0) {
					policyAmount = parseFloat(policy.policy_amount);
				} else if (policy.paymentOption === 'min') {
					policyAmount = parseFloat(policy.min_due || 0);
				} else if (policy.paymentOption === 'Full payment') {
					policyAmount = parseFloat(policy.total_due || 0);
				} else if (policy.paymentOption === 'No payment') {
					policyAmount = 0;
				}
			} else if (billingPaymentOption && hasAnyPolicyLevelOption) {
				if (billingPaymentOption === 'min') {
					policyAmount = parseFloat(policy.min_due || 0);
					policy.paymentOption = 'min';
				} else if (billingPaymentOption === 'Full payment') {
					policyAmount = parseFloat(policy.total_due || 0);
					policy.paymentOption = 'Full payment';
				} else if (billingPaymentOption === 'No payment') {
					policyAmount = 0;
					policy.paymentOption = 'No payment';
				}
			}
			// Priority 2: Only apply billing-level option if NO policies have their own options
			else if (billingPaymentOption && !hasAnyPolicyLevelOption) {
				if (billingPaymentOption === 'min') {
					policyAmount = parseFloat(policy.min_due || 0);
				} else if (billingPaymentOption === 'Full payment') {
					policyAmount = parseFloat(policy.total_due || 0);
				} else if (billingPaymentOption === 'No payment') {
					policyAmount = 0;
				}
			}
			// Priority 3: No payment option selected - default to min_due
			else {
				policyAmount = parseFloat(policy.min_due || 0);
			}

			// Update the policy's amount and summaryPolicyData
			policy.policy_amount = policyAmount;
			policy.summaryPolicyData = policyAmount;
			policy_total += policyAmount;
			hasAnyPolicyLevelOption = false; // Reset for next policy
		});

		// Set the billing account's payment_amount to the sum of all policies
		if(!billingPaymentOption){
			hasAnyPolicyLevelOption = false;
			accountData.payment_amount = policy_total;
		}
		
		// Add to grand total
		if (accountData.payment_amount >= 0) {
			total += parseFloat(accountData.payment_amount);
		}
	});

	return {
		...state,
		accounts: action.accountUpdate,
		total_amount_due: total
	};
		
	default:
			return state;
	}
}

export default accountReducer;



// WEBPACK FOOTER //
// ./src/reducers/accountReducer.js